import { TextKey } from '@mews-commander/enums';
import { PortfolioRateOverview } from '@mews-commander/data-access';
import { LocalizedText, useDialogAction } from '@mews/framework';
import { TooltippedSpan } from '@mews-commander/ui';
import { IconName, TableBulkActionButton } from '@optimus-web/core';
import { EditRateContainer } from '../../sections/components/rateForm/EditRateContainer';
import { RateFormProvider } from '../../sections/components/rateForm/hooks/RateFormProvider';
import { EDIT_RATE_BULK_STARTING_POINT, EDIT_RATE_SINGLE_STARTING_POINT } from '../../../utilities/userFlowTestIds';
import { getBulkEditVariables } from './getBulkEditVariables';

interface BulkEditProps {
    selectedRows: PortfolioRateOverview[];
    resetRowSelection: () => void;
}

export const BulkEdit = ({ selectedRows, resetRowSelection }: BulkEditProps) => {
    const editAction = useDialogAction(async () => Promise.resolve());

    const { isEditDisabled, disabledEditTooltipText, areRatesDependent, selectedRateIds, selectedPropertyIds } =
        getBulkEditVariables(selectedRows);

    return (
        <>
            <TooltippedSpan tooltip={isEditDisabled && <LocalizedText textKey={disabledEditTooltipText} />}>
                <TableBulkActionButton
                    data-test-id={
                        selectedRateIds.length > 1 ? EDIT_RATE_BULK_STARTING_POINT : EDIT_RATE_SINGLE_STARTING_POINT
                    }
                    icon={IconName.Edit}
                    onClick={editAction.handlers.handleOpen}
                    disabled={isEditDisabled}
                >
                    <LocalizedText textKey={TextKey.Edit} />
                </TableBulkActionButton>
            </TooltippedSpan>
            {editAction.states.isDialogOpened && (
                <RateFormProvider enterpriseIds={selectedPropertyIds} selectedRateIds={selectedRateIds}>
                    <EditRateContainer
                        areRatesDependent={areRatesDependent}
                        selectedRateIds={selectedRateIds}
                        selectedRateOverviews={selectedRows}
                        onSuccess={resetRowSelection}
                        {...editAction}
                    />
                </RateFormProvider>
            )}
        </>
    );
};
